import React from "react";
import PropTypes from "prop-types";
import { UploadPhotoContainer, RemoveImageV2, InputImage } from "./style";
import { UploadHDMIcon, CloseIconBranding, PromotionalDocIcon } from "../../../utils/icons";
import { getOrientation, resetOrientation, checkImage } from "../../../utils/methods";
import { imageErrorMessage } from "../../../utils/constants";
import { toast } from "react-toastify";
import { t } from "i18next";

class CommonImageUploader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      imgSrc: props.imgSrc || null,
      imageName: props.imageName || "",
    };
    this.fileInputRef = React.createRef();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.imgSrc !== this.props.imgSrc) {
      this.setState({ imgSrc: this.props.imgSrc });
    }
  }

  componentWillUnmount() {
    this.setState({ imgSrc: null });
  }

  onChange = (e) => {
    let file = e.target.files[0];

    if (!file) return;
    const { maxSizeMB, maxDimension } = this.props;
    const isSvg = file.type === 'image/svg+xml' || file.name.toLowerCase().endsWith('.svg');

    if (checkImage(e.target.files) || isSvg) {
      if ((file.size / 1000000) > maxSizeMB) {
        toast.error(`Please select an image file less than ${maxSizeMB}MB`);
        this.fileInputRef.current.value = '';
        return;
      }

      let reader = new FileReader();
      reader.readAsDataURL(file);
      const imageName = file.name;

      reader.onloadend = () => {
        const base64Result = reader.result;

        const applyImage = (src) => {
          if (maxDimension) {
            const fileInput = this.fileInputRef.current; // cache before async
            const img = new window.Image();
            img.onload = () => {
              if (img.width > maxDimension || img.height > maxDimension) {
                toast.error(`Image dimensions must not exceed ${maxDimension}x${maxDimension}px`);
                if (fileInput) fileInput.value = '';
                return;
              }
              this.setState({ imgSrc: src, imageName, editImage: src });
              if (this.props.onImageChange) this.props.onImageChange(src, imageName, src);
            };
            img.src = src;
          } else {
            this.setState({ imgSrc: src, imageName, editImage: src });
            if (this.props.onImageChange) this.props.onImageChange(src, imageName, src);
          }
        };


        //this.setState({ imgSrc: base64Result, imageName, editImage: base64Result });

        if (isSvg) {
          applyImage(base64Result);
        } else {
          getOrientation(file, (or) => {
            resetOrientation([base64Result], or, (baseImage) => {
              applyImage(baseImage);
            });
          });
        }
      };
    } else {
      toast.error(imageErrorMessage);
      this.fileInputRef.current.value = '';
    }
  };

  removePhoto = () => {
    this.setState({ imgSrc: null, imageName: "" });
    if (this.props.onRemoveImage) {
      this.props.onRemoveImage();
    }
  };

  render() {
    const { imgSrc, imageName } = this.state;
    const { disabled, type, ImageType, accept, label,showBorder } = this.props;
    
    return (
      <UploadPhotoContainer showBorder={type !== 'promotional' && imgSrc}>
        <div className="innerDivImageContainer">
          {imgSrc ? (
            type === 'promotional' ? (
              <RemoveImageV2>
                <div className="uploadImage">
                  <div className="promotional-doc">
                    <div className="promotional-doc-icon">{PromotionalDocIcon()}</div>
                    <div><span className="promotional-doc-name" title={imageName}>{imageName}</span></div>
                  </div>
                  {!disabled && (
                    <div className="main-div" onClick={() => !disabled && this.removePhoto()}>
                      <div className="icon-div">
                        <div className="sub-icon-div">{CloseIconBranding("#DA6C74", "8", "8")}</div>
                      </div>
                    </div>
                  )}
                </div>
              </RemoveImageV2>
            ) : (
              <RemoveImageV2 showBorder={showBorder}>
                <img alt="profile-img" src={imgSrc}></img>
                {!disabled && (
                  <div className="main-div" onClick={() => !disabled && this.removePhoto()}>
                    <div className="icon-div">
                      <div className="sub-icon-div">{CloseIconBranding("#DA6C74", "8", "8")}</div>
                    </div>
                  </div>
                )}
              </RemoveImageV2>
            )
          ) : (
            <div className="uploadImage">
              <InputImage
                className="edit-profile-pic"
                imageReload={1}
                style={{ background: "unset", color: "#184A61" }}
              >
                <div className="middle-section" onClick={() => this.fileInputRef.current.click()}>
                  <div>{UploadHDMIcon()}</div>
                  <div className="title">{label || t("Upload File")}</div>
                  {ImageType ?
                    <div className="sub-title">{(ImageType)}</div> :
                    <div className="sub-title">{t(`(${accept || ".jpeg, .png"})`)}</div>
                  }
                </div>
                <input
                  className="input-section"
                  id="upload-file"
                  type="file"
                  name="user"
                  accept={accept || ".jpeg, .png, .jpg"}
                  multiple={false}
                  onChange={(e) => this.onChange(e)}
                  onClick={(e) => { e.target.value = null; }}
                  ref={this.fileInputRef}
                />
              </InputImage>
            </div>
          )}
        </div>
      </UploadPhotoContainer>
    );
  }
}

CommonImageUploader.propTypes = {
  imgSrc: PropTypes.string,
  t: PropTypes.func.isRequired,
  onImageChange: PropTypes.func,
  onRemoveImage: PropTypes.func,
  disabled: PropTypes.bool,
  type: PropTypes.string,
  imageName: PropTypes.string,
  ImageType: PropTypes.string,
  accept: PropTypes.string,
  label: PropTypes.string,
  maxSizeMB: PropTypes.number,
  maxDimension: PropTypes.number,
  showBorder:PropTypes.bool
};

CommonImageUploader.defaultProps = {
  imgSrc: null,
  onImageChange: () => {},
  onRemoveImage: () => {},
  maxSizeMB: 20,
  maxDimension: null,
};

export default CommonImageUploader;
